import { useEffect, useState, useMemo } from 'react';

const useModelData = function(controller, loadedData, options, isReady) {
  // Current items
  const [pattern, setPattern] = useState(loadedData?.pattern ?? '');
  const [patternSvgId, setPatternSvgId] = useState(loadedData?.patternSvgId ?? '');
  const [patternSvgFile, setPatternSvgFile] = useState(loadedData?.patternSvgFile ?? '');
  const [collar, setCollar] = useState(loadedData?.collar ?? '');
  const [surfface, setSurfface] = useState(loadedData?.surfface ?? '');
  const [colorList, setColorList] = useState<Map<string, string>>();
  const [surfacelist, setSurfaceList] = useState<Map<string, string>>();

  // Data from manifest
  const [fonts, setFonts] = useState([]);
  const [flags, setFlags] = useState([]);
  const [palette, setPalette] = useState([]);
  const [patternList, setPatternList] = useState([]);
  const [collarList, setCollarList] = useState([]);
  const [surffaceList, setSurffaceList] = useState([]);

  useEffect(() => {
    loadedData?.colorList?.forEach(({ color, id }) => setColor(id, color));
    loadedData?.surfaceList?.forEach(({ surface, id }) => setSurface(id, surface));
  },[])

  useEffect(() => {
    const patternObj = patternList.find(item => item.id === pattern);
    if (controller.current) {
      setPatternSvgId(patternObj?.pattern_svg_id);
      setPatternSvgFile(patternObj?.pattern_svg_file);
      let args = patternObj?.layers?.map((el) => {
      let key = "color_"+el.index;
        return { color: colorList?.has(key) ? colorList.get(key) : undefined }
      });

      controller?.current?.setCurrentLayers(
        patternObj?.layers ?? [],
        args
      );
    }
  },[controller, pattern, patternList]);

  useEffect(() => {
    if (controller.current) {
      controller?.current?.onLayersUpdate((layers) => {
        setColorList(prevColorList => {
          if (prevColorList?.size > 0) {
            layers?.forEach(item => {
              prevColorList?.has(item.id) && controller?.current?.setLayerColor(item.id, prevColorList.get(item.id))
            });
          }
          return new Map(layers?.map(item => { 
            if(item.type === "logo") controller?.current?.setLayerColor(item.id, item.layer.color); 
            return [item.id, prevColorList?.has(item.id) ? prevColorList.get(item.id) : item.layer.color] 
          })) 
        });
      });
    }
  },[controller, patternList]);

  const setColor = (layerId, color) => {
    setColorList((prevColorList) => {
      const newColorList = new Map(prevColorList);
      newColorList.set(layerId, color);
      return newColorList;
    });
    controller?.current?.setLayerColor(layerId, color);
  };

  // Mouse mat
  const setSurface = (layerId, surface) => {
    setSurfaceList((prevSurfaceList) => {
      const newSurfaceList = new Map(prevSurfaceList);
      newSurfaceList.set(layerId, surface);
      return newSurfaceList;
    });
  }

  return {
    pattern,
    patternList,

    collar,
    collarList,
    surfface,
    surfacelist,
    surffaceList,

    fonts,
    setFonts,

    flags,
    setFlags,

    palette,
    setPalette,

    setCollarList,
    setSurfaceList,
    setSurffaceList,
    setPatternList,

    setPattern,
    setCollar,
    setSurface,
    setSurfface,

    colorList,
    setColor,

    patternSvgId,
    patternSvgFile
  }
};

export default useModelData;
